import React, { forwardRef } from 'react';

import { Stack, TextField } from '@mui/material';

import { DynamicSectionType } from '../../context/useDynamicSections';

interface Props {
  existingHeading?: string;
  existingSubheading?: string;
}

export enum SCHEDULE_HEADER_BLOCK_SECTION_FORM_NAMES {
  HEADING = 'header_block_section_heading',
  SUBHEADING = 'header_block_section_subheading',
}

export function parseHeaderBlockSectionFormData(formData: FormData, position = -1) {
  const getValue = (name: SCHEDULE_HEADER_BLOCK_SECTION_FORM_NAMES) =>
    (formData.get(name) as string | null | undefined) || '';
  return {
    type: DynamicSectionType.HEADER_BLOCK,
    heading: getValue(SCHEDULE_HEADER_BLOCK_SECTION_FORM_NAMES.HEADING),
    subheading: getValue(SCHEDULE_HEADER_BLOCK_SECTION_FORM_NAMES.SUBHEADING),
    position,
  };
}

const ScheduleHeaderBlockSectionForm = forwardRef<HTMLFormElement, Props>((props, ref) => {
  const { existingHeading = '', existingSubheading = '' } = props;

  return (
    <Stack component="form" ref={ref} direction="column" spacing={2} mt={1}>
      <TextField
        fullWidth
        label="Heading"
        name={SCHEDULE_HEADER_BLOCK_SECTION_FORM_NAMES.HEADING}
        defaultValue={existingHeading}
        variant="outlined"
        size="small"
      />
      <TextField
        fullWidth
        label="Subheading"
        name={SCHEDULE_HEADER_BLOCK_SECTION_FORM_NAMES.SUBHEADING}
        defaultValue={existingSubheading}
        variant="outlined"
        size="small"
      />
    </Stack>
  );
});

ScheduleHeaderBlockSectionForm.displayName = 'ScheduleHeaderBlockSectionForm';

export default ScheduleHeaderBlockSectionForm;
